import React from "react";

import { FaFacebookSquare } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";

const Footer = () => {
  return (
    <>
      <footer class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap md:text-left text-center order-first">
            <div class="lg:w-1/4 md:w-1/2 w-full px-4"></div>
          </div>
        </div>
        <div class="bg-gray-100">
          <div class="container px-5 py-6 mx-auto flex items-center sm:flex-row flex-col">
            <a
              href="/"
              class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
            >
              <img
                src="\Images\Logo\logo.png"
                alt=""
                className="lg:w-[40px] lg:h-[40px]  w-[40px] h-[40px] "
              />
              <span class="ml-3 text-xl">Smcooks</span>
            </a>

            <p class="text-sm text-gray-500 sm:ml-6 sm:mt-0 mt-4">
              © 2019 Smcooks
            </p>
            <div className=" lg:flex  grid grid-cols-3 lg:ml-[150px] mt-2 justify-between">
              <a href="/">
                <h1 className="mx-4 text-lg font-semibold">Home</h1>
              </a>
              <a href="/about">
                <h1 className="mx-4 text-lg font-semibold">About</h1>
              </a>
              <a href="/menu">
                <h1 className="mx-4 text-lg font-semibold">Menu</h1>
              </a>
              <a href="/staff">
                {" "}
                <h1 className="mx-4 text-lg font-semibold">Staff</h1>
              </a>
              <a href="/services">
                <h1 className="mx-4 text-lg font-semibold">Services</h1>
              </a>
              <a href="/contact">
                <h1 className="mx-4 text-lg font-semibold">Contact</h1>
              </a>
            </div>
            <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 px-2 py-2 justify-center sm:justify-start">
              <a href="/">
                <FaFacebookSquare className="w-6 h-6 mx-2 hover:text-indigo-500" />
              </a>
              <a href="https://www.youtube.com/@S.MCooks">
                <FaYoutube className="w-6 h-6 mx-2 hover:text-red-500" />
              </a>
              <a href="https://www.instagram.com/_sm_cooks_/?next=%2F">
                <AiFillInstagram className="w-6 h-6 mx-2 hover:text-pink-500" />
              </a>
            </span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
